import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';
import { FilesService } from 'src/app/shared/services/files.service';

@Component({
  selector: 'app-file-wyswyg',
  templateUrl: './file-wyswyg.component.html',
  styleUrls: ['./file-wyswyg.component.css']
})
export class FileWyswygComponent extends ElementComponent {
  @Input()
  public override data: any = {
  }

  private filesService: FilesService;

  constructor() {
    super()
    this.filesService = new FilesService();
    // TODO: suscripcion para actualizar el uploadData.fileName
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let src = this.data.src ?? "";
      this.data.filename = this.filesService.getFileName(src);
      this.data.extension = this.filesService.getFileExtension(src);
      this.data.iconClass = this.filesService.getFileIconClass(this.data.extension);
    }, 100);
  }

  onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.data.uploadData = {};

      this.data.src = URL.createObjectURL(file);
      this.data.filename = this.filesService.getFileName(file.name);

      this.data.extension = this.filesService.getFileExtension(file.name);
      this.data.iconClass = this.filesService.getFileIconClass(this.data.extension);

      this.filesService.getBase64File(file).then((base64File) => {
        this.data.uploadData = {
          base64File,
          fileName: file.name,
          contentType: file.type
        };
      });
    }
  }

}
